import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabThree() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > BIO METRIC </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            Biometrics is an advanced system of protection for many personal and industrial security systems. With its unique identifiers of biology and behavior, it can record the check-in and check-out of your employees and their time and attendance of them. Biometrics is always present with you and cannot be lost or forgotten.
                        </p>
                        <p className='service_des_p'>
                            Biometrics can be installed for fingerprint mapping, facial recognition, retina scans, etc. We will provide you with convenient and outstanding products that will suit your business needs. Make your business place safer through our biometrics installation services.
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> Advanced Security With Advanced Biometric System </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'>Biometric is an advanced and distinctive security system that records a person's attendance, exit and entry by simply identifying the characteristics.  </p>
                        <ul>
                            <li>Record Every Fingerprint</li>
                            <li>Helps In Business Security</li>
                        </ul>
                        <p className='service_des_p'> Biometric scanners are great security systems for offices as they record every detail of the employees. It is simply used by just registering the employee's details in the machine, and it will automatically record their characteristics. Furthermore, they are the best devices for offices as well as for employees' security. Connect with the excellent biometric dealers in Hyderabad and attain an advanced level of protection with satisfaction.</p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabThree